import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogComponent } from './dialog.component';
import { InsertionDirective } from './insertion.directive';
import { FocusTrapModule } from '../focus-trap/focus-trap.module';

@NgModule({
  declarations: [DialogComponent, InsertionDirective],
  imports: [CommonModule, FocusTrapModule],
  exports: [DialogComponent, InsertionDirective],
})
export class DialogModule {}
